import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './DocumentStatusCards.module.scss'
import Card from './components/Card'
import LastActionCard from '../LastActionCard/LastActionCard'

const DocumentStatusCards = ({ data, dataLastActions, is_all_statistic }) => {
  const { t } = useTranslation('common')
  return (
    <div className={styles.document_status_cards_wrapper}>
      <Card title={t('statistic.reports_card')} data={data?.raport} />
      <Card title={t('statistic.statements_card')} data={data?.statement} />

      {is_all_statistic ? '' : <LastActionCard data={dataLastActions} />}
    </div>
  )
}

export default DocumentStatusCards
